/**
 * LogProvider
 *
 * Always-on provider that pretty-prints every analytics call to the browser
 * console in debug mode. In production it is a no-op (debug mode is off).
 * Useful for local development with ?debug_analytics=1.
 */
import type { AnalyticsProvider, AnalyticsContext } from '../analytics';

export class LogProvider implements AnalyticsProvider {
  readonly name = 'log';

  async init(_ctx: AnalyticsContext): Promise<void> {}

  track(event: string, props: Record<string, unknown>): void {
    if (this.isDebug()) {
      console.debug(`%c[Analytics] track: ${event}`, 'color: #7c3aed; font-weight: bold', props);
    }
  }

  identify(userId: string, traits?: Record<string, unknown>): void {
    if (this.isDebug()) {
      console.debug(`%c[Analytics] identify: ${userId}`, 'color: #059669; font-weight: bold', traits);
    }
  }

  page(path: string, props?: Record<string, unknown>): void {
    if (this.isDebug()) {
      console.debug(`%c[Analytics] page: ${path}`, 'color: #2563eb; font-weight: bold', props);
    }
  }

  group(orgId: string, traits?: Record<string, unknown>): void {
    if (this.isDebug()) {
      console.debug(`%c[Analytics] group: ${orgId}`, 'color: #d97706; font-weight: bold', traits);
    }
  }

  reset(): void {
    if (this.isDebug()) {
      console.debug('%c[Analytics] reset', 'color: #dc2626; font-weight: bold');
    }
  }

  async flush(): Promise<void> {}

  private isDebug(): boolean {
    if (typeof window === 'undefined') return false;
    if (window.location.search.includes('debug_analytics=1')) return true;
    if (typeof sessionStorage !== 'undefined') {
      return sessionStorage.getItem('analytics_debug') === '1';
    }
    return false;
  }
}
